import React from 'react';
import PageWrapper from './PageWrapper';
import styled from 'styled-components'

import { MixerlabText } from './Components'

class SimpleMessageScreen extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log("We did this yesss")
  }

  render() {
    console.log("We did this yesss")
    return (
      <PageWrapper isAdmin={this.props.isAdmin}>
        <MixerlabText>
          <h3>{this.props.message}</h3>
          <a>{this.props.message2}</a>
        </MixerlabText>
      </PageWrapper>
    );
  }
}

export default SimpleMessageScreen;